export default __webpack_public_path__ + "static/media/blue-smoke.30ca25d6.webp";